/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface AssignRemoveOrgsFromOauthAppSpec { 
    service_type?: ServiceTypeEnum;
    /**
     * List of orgs to be added.
     */
    orgsToAdd?: Array<string>;
    /**
     * List of orgs to be removed from app.
     */
    orgsToRemove?: Array<string>;
}
export namespace AssignRemoveOrgsFromOauthAppSpec {
}


